import script from "./ExpenditureContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenditureContainer.vue?vue&type=script&setup=true&lang=js"

import "./ExpenditureContainer.vue?vue&type=style&index=0&id=0bd85fba&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd85fba"]])

export default __exports__